// Migration specification only. Runtime selections come exclusively from Firestore.
import catalog from './finalCemeteryCatalog.json';
export const APPROVED_CEMETERIES = catalog;
export const APPROVED_CITY_NAMES = Object.keys(catalog);
export const GRAVE_MAP_CEMETERIES = new Set([
  'Bakı|Yasamal qəbiristanlığı (Qurd qapısı)',
  'Bakı|Qurd qapısı qəbiristanlığı',
  'Gəncə|Səbiskar qəbiristanlığı',
]);
export const approvedCemeteryCount = Object.values(catalog).flat().length;
